import { Stack } from "@mui/material";
import { PaymentLayout } from "Components/Merchant/InitiatePaymentDetail/shared/PaymentLayout";
import { TransactionStatus } from "Infrastructure/Api/Api";
import { MerchantHeader } from "Components/Customer/Payment/MerchantHeader";
import { SuccessfulPaymentActions } from "Components/Merchant/InitiatePaymentDetail/SuccessfulPayment/SuccessfulPaymentActions";
import { ThankYouMessage } from "Components/Merchant/InitiatePaymentDetail/SuccessfulPayment/ThankYouMessage";

type Props = {
  amount: number;
  currencyCode: string;
  transactionPublicID: string;
  creditorName?: string | null;
  payPointPublicID?: string | null;
  merchantIdentityUserPublicID?: string | null;
  merchantProfilePicture?: string | null;
};

export const SuccessfulPaymentInfo = ({
  amount,
  currencyCode,
  transactionPublicID,
  creditorName,
  payPointPublicID,
  merchantIdentityUserPublicID,
  merchantProfilePicture,
}: Props) => (
  <PaymentLayout
    amount={amount}
    currencyCode={currencyCode}
    transactionPublicID={transactionPublicID}
    actionsSection={<SuccessfulPaymentActions />}
    transactionStatus={TransactionStatus.Success}
  >
    <Stack gap={4} alignItems="center" justifyContent="center" height="100%">
      <MerchantHeader
        creditorName={creditorName}
        payPointPublicID={payPointPublicID}
        merchantIdentityUserPublicID={merchantIdentityUserPublicID}
        merchantProfilePicture={merchantProfilePicture}
        size="large"
      />
      <ThankYouMessage />
    </Stack>
  </PaymentLayout>
);
